import { CloudOff, RefreshCw } from "lucide-react";
import { useIntl } from "react-intl";
import { cx } from "../cx.js";
import styles from "./ConnectionBanner.module.css";

export type ConnectionState =
  { status: "online" } | { status: "reconnecting"; seconds: number } | { status: "offline" };

/** Sichtbarer Verbindungsstatus (ARCHITEKTUR §10.7). Bei „online“ unsichtbar, aber live-Region bleibt. */
export function ConnectionBanner({ state }: { state: ConnectionState }) {
  const intl = useIntl();
  const text =
    state.status === "reconnecting"
      ? intl.formatMessage({ id: "connection.reconnecting" }, { seconds: state.seconds })
      : state.status === "offline"
        ? intl.formatMessage({ id: "connection.offline" })
        : "";
  return (
    <div
      role="status"
      aria-live="polite"
      className={cx(styles.bar, state.status !== "online" && styles.visible, styles[state.status])}
    >
      {state.status === "reconnecting" ? <RefreshCw className={styles.spin} aria-hidden="true" /> : null}
      {state.status === "offline" ? <CloudOff aria-hidden="true" /> : null}
      <span>{text}</span>
    </div>
  );
}

/** Kleiner Punkt für den Kopfbereich */
export function ConnectionDot({ state }: { state: ConnectionState }) {
  const intl = useIntl();
  return (
    <span className={cx(styles.dot, styles[`dot_${state.status}`])}>
      <span className={styles.led} aria-hidden="true" />
      {state.status === "online" ? intl.formatMessage({ id: "connection.online" }) : null}
    </span>
  );
}
